/* OddDrop consent bridge. Never sets the visitor's Shopify consent decision. */
(function () {
  'use strict';
  if (window.OddConsent) return;
  var state = { ready:false, analytics:false, marketing:false, sale:false };
  function update() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    if (!p || typeof p.analyticsProcessingAllowed !== 'function') return false;
    try {
      var next = { ready:true, analytics:p.analyticsProcessingAllowed() === true,
        marketing:typeof p.marketingAllowed === 'function' && p.marketingAllowed() === true,
        sale:typeof p.saleOfDataAllowed === 'function' && p.saleOfDataAllowed() === true };
      if (JSON.stringify(next) === JSON.stringify(state)) return true;
      state = next;
      if (typeof window.gtag === 'function') window.gtag('consent','update',{
        analytics_storage:state.analytics ? 'granted' : 'denied',
        ad_storage:state.marketing ? 'granted' : 'denied',
        ad_user_data:state.marketing && state.sale ? 'granted' : 'denied',
        ad_personalization:state.marketing && state.sale ? 'granted' : 'denied'
      });
      if (!state.analytics) {
        try { localStorage.removeItem('odddrop_channel_v1'); } catch (_) {}
        try { sessionStorage.removeItem('odddrop_search_context_v2'); sessionStorage.removeItem('od_item_list_context'); } catch (_) {}
      }
      document.dispatchEvent(new CustomEvent('od:consent',{detail:state}));
      return true;
    } catch (_) { return false; }
  }
  function load() {
    if (update()) return;
    var shopify = window.Shopify;
    if (shopify && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function (error) { if (!error) update(); });
    }
  }
  window.OddConsent = { allowed:function () { return state.ready && state.analytics && !(window.OddBrowserExclusion && window.OddBrowserExclusion.active()); },
    state:function () { return Object.assign({},state); }, refresh:update };
  document.addEventListener('visitorConsentCollected',update);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)update();});
  document.addEventListener('DOMContentLoaded',load);
  window.addEventListener('load',load,{once:true});
  load();
})();
